import bid from "@assets/web-v3-images/icons/bid.png";

const BidIcon = ({ width = 64, height = 64, className }) => (
  <img src={bid} alt="Bid Icon" width={width} height={height} className={className} />
);

export default BidIcon;
